import React, { useEffect, useState, useRef } from 'react';
import {
  FormWrapper,
  Title,
  ButtonLogin,
  ForgotPassword,
  Session,
  FieldWrapper,
  IconMail,
  ButtonGoBack,
  Container,
  RecaptchaWrapper
} from './styled';
import { COLORS } from '@app/src/ui';
import { reduxForm, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { renderInput } from '@app/src/common/Input/renderInput';
import * as validate from '@app/src/utils/validations';
import { Icon } from '@app/src/common/Icon';
import {
  ModalAccountActivationLogin,
  setUserName,
  fetchLogin,
  clearLoginData,
  clearValidateData,
  fetchValidate
} from '@app/src/common/session';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { clearPublishPackageData, publishPackage } from '@app/src/views/Package/listPackage';
import { Loading } from './styled';
import ReCAPTCHA from 'react-google-recaptcha';

const isClient = validate && validate.isClientEnv();
const PAYMENT_URL = '/pago-paquete';

interface Props {
  handleSubmit?: Function;
}

export const Form: React.FC<Props> = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const locationState = location && location.state;
  let urlFromBefore = locationState && locationState.from;
  const fromBefore = isClient && sessionStorage.getItem('from');

  const [isLoginAction, setIsLoginAction] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const categoryConfig = CATEGORIES[CATEGORY[userStorage && userStorage.categoryId]];
  const printStepFacturation = categoryConfig && categoryConfig.paths.purchasePrint.stepFacturation;

  const currentEmail = useSelector(state => state.form.login.values.email);
  const currentPassword = useSelector(state => state.form.login.values.password);
  const isLoading = useSelector(state => state.session.login.isFetching);
  const errorLogin = useSelector(state => state.session.login.error);
  const dataLogin = useSelector(state => state.session.login.data);
  const validateData = useSelector(state => state.session.validate.data);
  const isLoadingValidate = useSelector(state => state.session.validate.isFetching);
  const currentCategory = useSelector(state => state.package.categorySelected);
  const currentPackage = useSelector(state => state.package.packageSelected);
  const publish = useSelector(state => state.package.dataPublish);
  const isLodingPublish = useSelector(state => state.package.isFetchingPublish);

  const recatpchaKey = process.env.API_KEY_RECAPTCHA;
  // const [ token, setToken ] = useState('');
  const recaptchaRef = useRef(null);

  useEffect(() => {
    console.log(urlFromBefore,'urlFromBefore')
    console.log(fromBefore,'fromBefore')
    if (!urlFromBefore && fromBefore) {
      urlFromBefore = fromBefore;
    }
  }, []);

  useEffect(() => {
    if (dataLogin && dataLogin.inactive) {
      setIsShowModal(true);
      dispatch(clearLoginData());
    }
    if (dataLogin && dataLogin.jwt && isLoginAction && !errorLogin) {
      setIsLoginAction(false);
      dispatch(fetchValidate());
      dispatch(clearLoginData());
    }
  }, [dataLogin, isLoginAction, errorLogin]);

  useEffect(() => {
    if (validateData && validateData.name && userStorage && userStorage.jwt) {
      const currentStorage = isClient && JSON.parse(localStorage.getItem('user'));
      dispatch(setUserName(validateData && validateData.name));
      const newStorage = {
        ...currentStorage,
        isLogin: true,
        data: validateData
      };
      isClient && localStorage.setItem('user', JSON.stringify(newStorage));
      dispatch(clearValidateData());
      if (urlFromBefore === 'purchase-package') {
        dispatch(publishPackage(currentCategory, currentPackage));
      } else if (urlFromBefore === 'purchase-print') {
        history.push(`${categoryConfig.paths.purchasePrint.stepFacturation}/${userStorage && userStorage.uniqueId}`);
      } else {
        history.push('/mi-cuenta');
      }
    }
  }, [validateData, currentCategory, currentPackage, urlFromBefore]);

  useEffect(() => {
    if (publish && publish.unique_id && categoryConfig) {
      const updateUser = {
        ...userStorage,
        packageId: currentPackage,
        categoryId: currentCategory,
        user: validateData && validateData.id,
        uniqueId: publish.unique_id
      }
      isClient && localStorage.setItem('user', JSON.stringify(updateUser));
      dispatch(clearPublishPackageData());
      if (urlFromBefore === 'purchase-package') {
        history.push(`${PAYMENT_URL}${updateUser && updateUser.urlGenerated}/${updateUser && updateUser.uniqueId}`);
      } else if (urlFromBefore === 'purchase-print') {
        history.push(`${printStepFacturation}/${updateUser && updateUser.uniqueId}`);
      } else {
        history.push('/');
      }
    }
  }, [publish, currentCategory, urlFromBefore]);

  const handleClickSubmit = (data): void => {
    const token = recaptchaRef.current.getValue();
    if (token) {
      setIsLoginAction(true);
      dispatch(fetchLogin(data, token));
      recaptchaRef.current.reset();
    }
  };

  const handleClickRegistry = (e): void => {
    e.preventDefault();
    history.push('/registrate', { from: urlFromBefore });
  };

  const handleClickForgotPassword = (e) => {
    e.preventDefault();
    history.push('/cambiar-contrasena');
  };

  const handleClickCloseModal = () => {
    setIsShowModal(false);
  };

  const handleClickBack = (e) => {
    e.preventDefault();
    if (urlFromBefore === 'purchase-package') {
      history.push(categoryConfig.paths.purchasePackage.stepSelection);
    } else if (urlFromBefore === 'purchase-print') {
      history.push(`${categoryConfig.paths.purchasePrint.stepSummary}/${userStorage && userStorage.uniqueId}`);
    } else {
      history.push('/');
    }
  };

  return (
    !isLoadingValidate ? <Container>
      <ButtonGoBack href="#" onClick={handleClickBack}>
        <Icon data-name="icon-back" width="16" height="16" fill={COLORS.BLACK_BOLD} />Regresar</ButtonGoBack>
      <FormWrapper onSubmit={handleSubmit(handleClickSubmit)}>
        <Title>Ingresa a tu cuenta</Title>
        <FieldWrapper>
          <Field
            name="email"
            placeholder="Email"
            maxLength={80}
            component={renderInput}
            validate={[validate.required, validate.email]}
            iconLeft={<IconMail><Icon data-name="icon-mail" width="20" height="20" fill="#ccc" /></IconMail>}
            defaultValue={currentEmail}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            name="password"
            type="password"
            placeholder="Contraseña"
            maxLength={16}
            component={renderInput}
            validate={[validate.required, validate.minLength8, validate.minimeOneNumber, validate.minimeOneLetter]}
            defaultValue={currentPassword}
          />
        </FieldWrapper>
        <RecaptchaWrapper>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={recatpchaKey}
          />
        </RecaptchaWrapper>
        <ForgotPassword href="#" onClick={handleClickForgotPassword}>Olvidé mi contraseña</ForgotPassword>
        <ButtonLogin
          type="submit"
          background={COLORS.BLACK}
          // handleClick={}
          loading={isLoading || isLoadingValidate || isLodingPublish}
          color="#fff"><strong>Ingresar</strong>
        </ButtonLogin>
        <Session>No tengo cuenta, <a onClick={handleClickRegistry}>registrarme</a></Session>
      </FormWrapper>
      <ModalAccountActivationLogin
        showModal={isShowModal}
        closeModal={handleClickCloseModal}
      />
    </Container> : <Loading>cargando...</Loading>
  )
};

const FormLoginHoc = reduxForm({
  form: 'login',
  initialValues: {
    email: '',
    password: ''
  }
})(Form);

export { FormLoginHoc as FormLogin }
